module.exports = __webpack_public_path__ + "img/ico_refresh.19891e46.svg";